"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Constants = require("FileManagerCore/Constants");

var _Files = require("FileManagerCore/actions/Files");

var _file = require("FileManagerCore/utils/file");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _ImageEditor = _interopRequireDefault(require("FileManagerCore/components/ImageEditor"));

var _EditAndCreateImage = require("FileManagerCore/selectors/EditAndCreateImage");

var EditButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(EditButton, _Component);

  function EditButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EditButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditButton).call(this, props));
    _this.mounted = false;
    _this.state = {
      showImageEditor: false
    };
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCropSave = _this.handleCropSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResizeSave = _this.handleResizeSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EditButton, [{
    key: "handleSave",
    value: function handleSave(file, newFile, newUrl) {
      var _this$props = this.props,
          onSave = _this$props.onSave,
          onSaveComplete = _this$props.onSaveComplete;
      onSave(file, newFile, newUrl).then(function (savedFile) {
        if (onSaveComplete) {
          onSaveComplete(savedFile.get('url'), savedFile);
        }
      });
    }
  }, {
    key: "handleCropSave",
    value: function handleCropSave(file, fileName, folderId) {
      var _this$props2 = this.props,
          dispatchUploadEditedImage = _this$props2.dispatchUploadEditedImage,
          onSaveComplete = _this$props2.onSaveComplete;
      dispatchUploadEditedImage(file, fileName, folderId, onSaveComplete);
    }
  }, {
    key: "handleResizeSave",
    value: function handleResizeSave(file, newWidth) {
      var _this$props3 = this.props,
          dispatchUploadResizedImage = _this$props3.dispatchUploadResizedImage,
          onSaveComplete = _this$props3.onSaveComplete;
      dispatchUploadResizedImage(file, newWidth, onSaveComplete);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          file = _this$props4.file,
          children = _this$props4.children,
          selectedImgFrom = _this$props4.selectedImgFrom,
          dispatchSelectImageToEdit = _this$props4.dispatchSelectImageToEdit,
          dispatchDeselectImageToEdit = _this$props4.dispatchDeselectImageToEdit,
          openedFrom = _this$props4.openedFrom,
          size = _this$props4.size,
          use = _this$props4.use;

      if (!(0, _file.isAnimation)(file)) {
        return selectedImgFrom === _Constants.ImageEditorLocations.SOCIAL_PREVIEW ? _react.default.createElement(_ImageEditor.default, {
          onClose: function onClose() {
            return dispatchDeselectImageToEdit();
          },
          onCropSave: this.handleCropSave,
          onResizeSave: this.handleResizeSave
        }) : _react.default.createElement(_UIButton.default, {
          onClick: function onClick() {
            return dispatchSelectImageToEdit(file, openedFrom);
          },
          size: size,
          use: use
        }, children || _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.cloneAndEdit"
        }));
      }

      return null;
    }
  }]);
  return EditButton;
}(_react.Component);

EditButton.propTypes = {
  children: _react.PropTypes.node,
  dispatchSelectImageToEdit: _react.PropTypes.func.isRequired,
  dispatchDeselectImageToEdit: _react.PropTypes.func.isRequired,
  dispatchUploadResizedImage: _react.PropTypes.func.isRequired,
  dispatchUploadEditedImage: _react.PropTypes.func.isRequired,
  file: _react.PropTypes.instanceOf(_immutable.default.Map),
  onSave: _react.PropTypes.func.isRequired,
  onSaveComplete: _react.PropTypes.func,
  openedFrom: _react.PropTypes.string,
  selectedImgFrom: _react.PropTypes.string.isRequired,
  size: _UIButton.default.propTypes.size,
  use: _UIButton.default.propTypes.use
};
EditButton.defaultProps = {
  openedFrom: _Constants.ImageEditorLocations.SOCIAL_PREVIEW,
  use: 'tertiary-light',
  size: 'xs'
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSave: function onSave(file, newFile, newUrl) {
      var fileId = file ? file.get('id') : null;
      return dispatch((0, _Files.saveEdit)(fileId, newFile, newUrl));
    },
    dispatchUploadEditedImage: function dispatchUploadEditedImage(file, fileName, folderId, onSaveComplete) {
      return dispatch((0, _Files.uploadEditedImage)(file, fileName, folderId, onSaveComplete));
    },
    dispatchUploadResizedImage: function dispatchUploadResizedImage(fileId, newWidth) {
      return dispatch((0, _Files.uploadResizedImage)(fileId, newWidth));
    },
    dispatchSelectImageToEdit: function dispatchSelectImageToEdit(file, selectedFrom) {
      return dispatch((0, _Files.getSelectImageToEditAction)(file, selectedFrom));
    },
    dispatchDeselectImageToEdit: function dispatchDeselectImageToEdit() {
      return dispatch((0, _Files.getDeselectImageToEditAction)());
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedImgFrom: (0, _EditAndCreateImage.getSelectedImageFrom)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditButton);

exports.default = _default;
module.exports = exports.default;